// Where a customer is told to go for help.
//
// One constant rather than an address typed into each string, because every
// copy of it is a place the address can go stale, and because the support
// agent plan (live-captions/SUPPORT_AGENT_PLAN.md) makes this the fallback
// its kill switch flips every surface back to: "Support is on email today --
// support@airchain.tv". When a chat widget ships, the widget checks in here
// rather than each call site learning about it.
const SUPPORT_EMAIL = 'support@airchain.tv';
const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

export { SUPPORT_EMAIL, SUPPORT_MAILTO };
